import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  fill: "none",
  viewBox: "0 0 17 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.139 2V1h5v5h-1V2.707L9.846 7l-.707-.709L13.432 2zM6.435 9l.704.708L2.846 14h3.293v1h-5v-5h1v3.293z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }